import 'element-ui/lib/theme-chalk/icon.css';
import App from './App';
import { createRouter } from './router';
import { createStore } from './store/index';
import { scrollTo } from '@/helper/iframeEvent';
import initClientApp from '@/system/init/init-client-app';
import { setIfrHeightByURL, configIframeURL } from '@/helper/iframeEvent';
import { throttle } from 'lodash';
import TKDMixin from '@/helper/TKD';

const locales = require.context('./locales/', false, /\.js$/);

function getAppInitParams () {
  const router = createRouter();
  const store = createStore();

  router.beforeResolve((to, from, next) => {
    if (typeof window !== 'undefined') {
      scrollTo(0);
    }
    next();
  });

  return {
    router,
    store,
    locales,
    App
  };

  // setLanguage('zh-CN');
}

configIframeURL('https://shop.nubia.com/recycle.php?a=getHeight#', 'https://shop.nubia.com/recycle.php?a=setTop#');

const throttledSet = throttle(setIfrHeightByURL, 500);
document.body.addEventListener('click', () => {
  setTimeout(throttledSet, 200);
});

initClientApp(getAppInitParams(), {
  pageLoaded (app, store, router) {
    TKDMixin(app, router.currentRoute, store, app.$t.bind(app));
    setTimeout(() => {
      throttledSet();
    }, 500);
  }
});
